import { render, staticRenderFns } from "./PostFitOutReviewerHistory.vue?vue&type=template&id=406ece80&scoped=true&"
import script from "./PostFitOutReviewerHistory.vue?vue&type=script&lang=js&"
export * from "./PostFitOutReviewerHistory.vue?vue&type=script&lang=js&"
import style0 from "./PostFitOutReviewerHistory.vue?vue&type=style&index=0&id=406ece80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406ece80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('406ece80')) {
      api.createRecord('406ece80', component.options)
    } else {
      api.reload('406ece80', component.options)
    }
    module.hot.accept("./PostFitOutReviewerHistory.vue?vue&type=template&id=406ece80&scoped=true&", function () {
      api.rerender('406ece80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/postFitOutLetter/PostFitOutReviewerHistory.vue"
export default component.exports